import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';

function Hero() {
  const titleRef = useRef();
  const subtitleRef = useRef();
  const iconsRef = useRef();

  const illustrations = [
    { src: '/icons/heart with wings (front).png', delay: 0.5 },
    { src: '/icons/cards (front).png', delay: 0.7 },
    { src: '/icons/ring.png', delay: 0.9 },
    { src: '/icons/smile (front).png', delay: 1.1 },
    { src: '/icons/coffee.png', delay: 1.3 }
  ];

  useEffect(() => {
    gsap.fromTo(
      titleRef.current,
      { opacity: 0, y: 100 },
      { opacity: 1, y: 0, duration: 1.2, ease: 'power4.out' }
    );

    gsap.fromTo(
      subtitleRef.current,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1, delay: 0.3, ease: 'power3.out' }
    );

    // Animate illustrations
    const icons = iconsRef.current.querySelectorAll('.hero-icon');
    icons.forEach((icon, index) => {
      gsap.fromTo(
        icon,
        { opacity: 0, y: 100, rotation: -20 },
        { 
          opacity: 1, 
          y: 0, 
          rotation: 0,
          duration: 1.2, 
          delay: illustrations[index].delay,
          ease: 'elastic.out(1, 0.5)'
        }
      );

      // Floating animation
      gsap.to(icon, {
        y: -15,
        duration: 2 + (index * 0.3),
        repeat: -1,
        yoyo: true,
        ease: 'power1.inOut',
        delay: illustrations[index].delay + 1
      });
    });
  }, []);

  return (
    <section className="hero">
      <div className="hero-content">
        <h1 ref={titleRef} className="hero-title">
          For My Valentine
        </h1>
        <p ref={subtitleRef} className="hero-subtitle">
          A special journey created just for you, Sojin Kim
        </p>

        <div ref={iconsRef} className="hero-illustrations">
          {illustrations.map((illustration, index) => (
            <div key={index} className="hero-icon">
              <img src={illustration.src} alt={`Illustration ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
      
      <div className="scroll-hint">
        Scroll to continue ↓
      </div>
    </section>
  );
}

export default Hero;